import React from 'react'
import FinancialAccountReconciliationsTable from '../reconciliation/Components/FinancialAccountReconciliationsTable'
import { Card, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

interface Props {
  userId: number
}

export const FinancialAccountReconciliationsCard: React.FC<Props> = ({
  userId,
}) => (
  <Card className="w-full">
    <Text variant={TypographyStyles.H2}>Reconciliations</Text>
    <br />
    <FinancialAccountReconciliationsTable userId={userId} />
  </Card>
)
